import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, switchMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { createUserActivityLogAction, createUserActivityLogSuccessAction, createUserActivityLogFailureAction } from './create-user-activity-log.actions';
import { CreateUserActivityLogService } from '../create-user-activity-log.service';

@Injectable()
export class CreateUserActivityLogEffects {
  createUserActivityLog$ = createEffect(() => this.actions$.pipe(
    ofType(createUserActivityLogAction),
    switchMap(action =>
      this.createUserActivityLogService.create(action.payload).pipe(
        map(data => createUserActivityLogSuccessAction({ data })),
        catchError(error => of(createUserActivityLogFailureAction({ error }))),
      )
    )
  ));

  constructor(
    private actions$: Actions,
    private createUserActivityLogService: CreateUserActivityLogService,
  ) {
  }
}
